import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@gulshanone29.com");
  const [password, setPassword] = useState("Admin@123");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      {/* Left form */}
      <div className="flex items-center justify-center px-10 py-16 bg-white">
        <div className="w-full max-w-sm fade-up">
          <div className="mb-12 flex items-center gap-3">
            <img src="/brand/gulshan-logo.jpg" alt="Gulshan ONE29" className="h-14 w-auto object-contain shrink-0" />
            <div>
              <div className="text-lg font-light" style={{ fontFamily: "Outfit" }}>Gulshan ONE29</div>
              <div className="label-tiny">Loyalty Platform</div>
            </div>
          </div>

          <h1 className="text-4xl font-light mb-3" style={{ fontFamily: "Outfit" }}>Sign in</h1>
          <p className="text-[#8C8C8C] mb-10 text-sm">Access the loyalty dashboard for your mall.</p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <div className="label-tiny mb-2">Email</div>
              <input
                type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="fin" data-testid="login-email"
              />
            </div>
            <div>
              <div className="label-tiny mb-2">Password</div>
              <input
                type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="fin" data-testid="login-password"
              />
            </div>
            {err && <div className="text-[13px] text-[#8C3A3A]" data-testid="login-error">{err}</div>}
            <button type="submit" disabled={loading} className="btn-dark w-full flex items-center justify-center gap-2" data-testid="login-submit">
              {loading && <Loader2 size={14} className="animate-spin" />}
              Sign in
            </button>
          </form>

          <div className="mt-16 flex items-center gap-3 text-[#8C8C8C]">
            <span className="label-tiny">Powered by</span>
            <img src="/brand/fundle-logo.png" alt="Fundle" className="h-4 invert opacity-70" />
          </div>
        </div>
      </div>

      {/* Right image */}
      <div className="hidden lg:block relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1600&q=80)" }}
        />
        <div className="absolute inset-0 bg-[#1A1A1A]/45" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="label-tiny mb-3" style={{ color: "rgba(255,255,255,0.55)" }}>Welcome</div>
          <h2 className="text-5xl font-extralight leading-tight tracking-tight" style={{ fontFamily: "Outfit" }}>
            A loyalty experience<br />worthy of the brand.
          </h2>
          <p className="mt-6 max-w-md text-white/70 text-[14px] leading-relaxed">
            Manage brands, locations, offers and customer rewards across Gulshan ONE29.
            Designed for premium retail.
          </p>
        </div>
      </div>
    </div>
  );
}
